// extracted by mini-css-extract-plugin
export default {"content":"rI-z","lookName":"sI-z","shopTheLookContainer":"tI-z","productContainer":"uI-z","imageContainer":"vI-z","mainImage":"wI-z"};